module.exports = __webpack_public_path__ + "img/transformer-pole.218a3792.jpg";